import { type ReactNode } from 'react';
import { messages } from '../i18n/messages.js';
import { useSession } from '../app/session-context.js';
import { StatusesPanel } from './ReferenceScreen.js';

/** Statuslar — kod va o'tishlar tahrirlanmaydi, faqat matn va push. */
export function StatusesScreen(): ReactNode {
  const { locale } = useSession();
  const t = messages(locale);

  return (
    <section className="adm-page">
      <header className="adm-page__header">
        <h1 className="adm-page__title">{t.refStatuses}</h1>
      </header>
      <StatusesPanel hideTitle />
    </section>
  );
}
